// const IP = "http://127.0.0.1:8000";
const IP = "https://www.zomatel-madagascar.com";

export const baseUrl = `${IP}/`; // for react image url
export const apiUrl = `${IP}/api`; // for the api
export const frontUrl = "https://www.zomatel-madagascar.com/"; // for react url
